<script lang="ts">
	import { sidebarOpen } from '$stores/sidebar';
	import { page } from '$app/stores';

	const navItems = [
		{ path: '/', label: 'Home' },
		{ path: '/playground', label: 'Playground' },
		{ path: '/docs', label: 'Documentation' }
	];

	function handleLinkClick() {
		sidebarOpen.close();
	}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
	class="fixed inset-0 z-50 md:hidden"
	on:click={() => sidebarOpen.close()}
>
	<!-- Backdrop -->
	<div class="absolute inset-0 bg-black bg-opacity-50" />

	<!-- Menu Panel -->
	<div class="absolute right-0 top-0 h-full w-64 bg-white shadow-lg" on:click|stopPropagation>
		<div class="p-4">
			<button class="absolute top-4 right-4" on:click={() => sidebarOpen.close()}>
				<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M6 18L18 6M6 6l12 12"
					/>
				</svg>
			</button>

			<nav class="mt-12">
				<ul class="space-y-4">
					{#each navItems as item}
						<li>
							<a
								href={item.path}
								class="block px-4 py-2 rounded-md text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
								class:bg-blue-100={$page.url.pathname === item.path}
								class:text-blue-600={$page.url.pathname === item.path}
								class:font-semibold={$page.url.pathname === item.path}
								on:click={handleLinkClick}
							>
								{item.label}
							</a>
						</li>
					{/each}
				</ul>

				<div class="mt-8 pt-8 border-t border-gray-200">
					<a
						href="https://github.com/ishansasika/svelte-perfect-select"
						target="_blank"
						rel="noopener noreferrer"
						class="flex items-center px-4 py-2 text-gray-700 hover:text-blue-600"
					>
						<svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
							<path
								d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"
							/>
						</svg>
						GitHub
					</a>
				</div>
			</nav>
		</div>
	</div>
</div>
